import { cx } from 'class-variance-authority';
import {
  type ComponentPropsWithoutRef,
  useContext,
  useId,
  useRef,
} from 'react';
import { type AriaRadioProps, useRadio } from 'react-aria';
import type { RadioGroupState } from 'react-stately';

import { RadioContext } from './ChooseButtonGroup';

const ChooseButton = (
  props: AriaRadioProps & ComponentPropsWithoutRef<'label'>,
): JSX.Element => {
  const { children, className } = props;
  const state: RadioGroupState = useContext(RadioContext)!;
  const ref = useRef<HTMLInputElement>(null);
  const id = useId();
  const { inputProps, isSelected, isDisabled } = useRadio(props, state, ref);

  return (
    <div>
      <input
        {...inputProps}
        id={id}
        className="peer absolute appearance-none"
        ref={ref}
      />
      <label
        data-value={props.value}
        htmlFor={id}
        className={cx(
          className,
          'cursor-pointer overflow-hidden rounded-lg border hover:border-white hover:bg-white',
          {
            'pointer-events-none cursor-default opacity-30': isDisabled,
            'border-sandstone-500 bg-white hover:border-sandstone-500':
              isSelected,
            'border-gray-150 bg-gray-150': !isSelected,
          },
        )}
      >
        {children}
      </label>
    </div>
  );
};

export default ChooseButton;
